"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allCurrencies = exports.Currency = void 0;
var Currency;
(function (Currency) {
  Currency["dollar"] = "USD";
  Currency["euro"] = "EUR";
  Currency["ruble"] = "RUB";
  Currency["shekel"] = "ILS";
})(Currency = exports.Currency || (exports.Currency = {}));
exports.allCurrencies = [Currency.euro, Currency.dollar, Currency.ruble, Currency.shekel];